module.exports = __webpack_public_path__ + "assets/01eab6628446b59cdb1a2dda8d258703.png";